webpackJsonp([291],{

/***/ 1308:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserOrderStatDetail_vue__ = __webpack_require__(3076);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ccbd6a5e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserOrderStatDetail_vue__ = __webpack_require__(5759);
function injectStyle (ssrContext) {
  __webpack_require__(5757)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ccbd6a5e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserOrderStatDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ccbd6a5e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserOrderStatDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2504:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      tableFields: [{ prop: 'userid', label: '用户ID', width: 100 }, { prop: 'realname', label: '用户真实姓名', width: 120 }, { prop: 'cellphone', label: '用户手机号', width: 150 }, { prop: 'usertype', label: '用户类型', width: 100 }, { prop: 'task_types', label: '任务类型', width: 200 }, { prop: 'tags', label: '标签', width: 200 }, { prop: 'current_location', label: '当前心跳位置', width: 200 }, { prop: 'id_card_location', label: '身份证覆盖位置', width: 200 }, { prop: 'all_approved_rate', label: '综合做单准确率', width: 120 }, { prop: 'order_rank_avg', label: '做单质量(平均分)', width: 150 }, { prop: 'order_canceled_avg', label: '恶意弃单率(%)', width: 120 }, { prop: 'order_canceled_cnt', label: '恶意弃单次数', width: 120 }, { prop: 'order_total_cnt', label: '抢单总次数', width: 120 }, { prop: 'all_approved_cnt', label: '做单数量', width: 100 }, { prop: 'customer_count', label: '参与客户数量', width: 120 }, { prop: 'evidence_types', label: '证据类型', width: 100 }, { prop: 'registertime', label: '注册时间', width: 160 }, { prop: 'last_active_tp', label: '最后活跃时间', width: 160 }, { prop: 'cumulative_bounty', label: '累计做单金额', width: 150 }],
      detailFields: [{ prop: 'userid', label: '用户ID' }, { prop: 'realname', label: '用户真实姓名' }, { prop: 'cellphone', label: '用户手机号' }, { prop: 'usertype', label: '用户类型' }, { prop: 'task_types', label: '任务类型' }, { prop: 'tags', label: '标签', allowToggle: true }, { prop: 'tag_groups', label: '标签组' }, { prop: 'current_location', label: '当前心跳位置' }, { prop: 'id_card_location', label: '身份证覆盖位置' }, { prop: 'order_rank_info', label: '做单质量(平均分)' }, { prop: 'order_canceled_avg', label: '恶意弃单率(%)' }, { prop: 'order_canceled_cnt', label: '恶意弃单次数' }, { prop: 'order_total_cnt', label: '抢单总次数' }, { prop: 'all_approved_cnt', label: '做单(已通过)数量' }, { prop: 'evidence_types', label: '证据类型' }, { prop: 'registertime', label: '注册时间' }, { prop: 'last_active_tp', label: '最后活跃时间' }, { prop: 'cumulative_bounty', label: '累计做单金额(元)' }, { prop: 'customer_count', label: '参与客户数量' }, { prop: 'customer_ids', label: '参与客户列表', allowToggle: true }, { prop: 'order_covered_nonsubmitted_locations', label: '签到未提交工单覆盖', allowToggle: true }, { prop: 'order_covered_rejected_locations', label: '提交未通过工单覆盖', allowToggle: true }, { prop: 'order_covered_approved_locations', label: '审核通过工单覆盖', allowToggle: true }, { prop: 'order_measurement_all_approved_rate', label: '综合做单数据' }]
    };
  }
});

/***/ }),

/***/ 3076:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__userOrderStat_mixins__ = __webpack_require__(2504);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      id: null,
      table: [],
      newDetailFields: []
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3__userOrderStat_mixins__["a" /* default */]],
  created: function created() {
    this.id = this.$route.params.userid;
    this.id > 0 && this.setDetailData(this.id);
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    orderOptions: function orderOptions(state) {
      return state.order.options;
    },
    userOptions: function userOptions(state) {
      return state.users.options;
    },
    userOrderStat: function userOrderStat(state) {
      return state.userOrderStat;
    }
  })),
  methods: {
    setDetailData: function setDetailData(id) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return request.common('getUserOderStatDetailApi', { id: id }).then(function (_ref) {
                  var data = _ref.data;

                  var usertype = _this.userOptions.type.find(function (it) {
                    return it.value + '' === data.usertype + '';
                  });
                  data.usertype = _.get(usertype, 'label', data.usertype);
                  data.task_types = data.task_types.join(' , ');
                  data.tags = data.tags.join(' , ');
                  data.tag_groups = data.tag_groups.join(' , ');
                  data.current_location = data.current_location.join(' - ');
                  data.id_card_location = data.id_card_location.join(' - ');
                  data.all_approved_rate = _this.multiplyBy100(_.get(data, 'order_measurement.all.approved_rate', 0), 2, '%');
                  data.order_canceled_avg = _this.multiplyBy100(_.get(data, 'order_canceled_avg', 0), 2, '%');
                  data.all_approved_cnt = _.get(data, 'order_measurement.all.approved_cnt', 0);
                  data.evidence_types = data.evidence_types.map(function (it) {
                    return _this.userOrderStat.evidenceTypeMap[it];
                  }).join(' , ');
                  data.customer_ids = data.customer_ids.join(' , ');
                  data.order_covered_nonsubmitted_locations = data.order_covered_nonsubmitted_locations.map(function (it) {
                    return it.join('-');
                  }).join('， ');
                  data.order_covered_rejected_locations = data.order_covered_rejected_locations.map(function (it) {
                    return it.join('-');
                  }).join('， ');
                  data.order_covered_approved_locations = data.order_covered_approved_locations.map(function (it) {
                    return it.join('-');
                  }).join('， ');
                  data.last_active_tp = data.last_active_tp === '1970-01-01 00:00:00' ? '-' : data.last_active_tp;
                  data.order_rank_info = { '平均分': data.order_rank_avg, '总得分': data.order_rank_total, '已评分工单数': data.order_rank_cnt };

                  for (var taskTypeId in data.order_measurement) {
                    if (data.order_measurement.hasOwnProperty(taskTypeId)) {
                      data['order_measurement_' + taskTypeId + '_approved_rate'] = {
                        '审单通过工单数量': data.order_measurement[taskTypeId].approved_cnt,
                        '工单审核次数': data.order_measurement[taskTypeId].reviewed_times,
                        '准确率': _this.multiplyBy100(data.order_measurement[taskTypeId].approved_rate, 2, '%')
                      };
                    }
                  }

                  var newDetailFields = _.cloneDeep(_this.detailFields);
                  _this.orderOptions.type.forEach(function (it) {
                    var newPropStr = 'order_measurement_' + it.value + '_approved_rate';
                    if (data.hasOwnProperty(newPropStr)) {
                      var labelStr = it.label + (it.deprecated ? '(已禁用)' : '');
                      newDetailFields.push({
                        prop: newPropStr,
                        label: labelStr + ' \u7C7B\u4EFB\u52A1\u505A\u5355\u6570\u636E'
                      });
                    }
                  });

                  newDetailFields.forEach(function (_ref2) {
                    var prop = _ref2.prop,
                        label = _ref2.label,
                        formatter = _ref2.formatter,
                        allowToggle = _ref2.allowToggle;

                    _this.table.push({
                      prop: prop,
                      label: label,
                      allowToggle: allowToggle,
                      value: formatter ? formatter(data) : _.get(data, prop, ''),
                      expanded: false
                    });
                  });
                });

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    multiplyBy100: function multiplyBy100(num) {
      var digit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
      var suffix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

      var str = (num * 100).toFixed(digit);
      return Number(str) + suffix;
    },
    toggleContent: function toggleContent(index) {
      this.table[index].expanded = !this.table[index].expanded;
    }
  }
});

/***/ }),

/***/ 5757:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5758);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("3819e9ce", content, true, {});

/***/ }),

/***/ 5758:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".content-wrapper[data-v-ccbd6a5e]{position:relative}.content-clamped[data-v-ccbd6a5e]{display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden;text-overflow:ellipsis;line-height:1.5}.content-full[data-v-ccbd6a5e]{line-height:1.5}.toggle-btn[data-v-ccbd6a5e]{margin-top:5px;padding:0;color:#409eff}", "", {"version":3,"sources":["/workspace/src/views/user-order-stat/pages/UserOrderStatDetail.vue"],"names":[],"mappings":"AACA,kCAAkC,iBAAiB,CAClD,AACD,kCAAkC,oBAAoB,qBAAqB,4BAA4B,gBAAgB,uBAAuB,eAAe,CAC5J,AACD,+BAA+B,eAAe,CAC7C,AACD,6BAA6B,eAAe,UAAU,aAAa,CAClE","file":"UserOrderStatDetail.vue","sourcesContent":["\n.content-wrapper[data-v-ccbd6a5e]{position:relative\n}\n.content-clamped[data-v-ccbd6a5e]{display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden;text-overflow:ellipsis;line-height:1.5\n}\n.content-full[data-v-ccbd6a5e]{line-height:1.5\n}\n.toggle-btn[data-v-ccbd6a5e]{margin-top:5px;padding:0;color:#409EFF\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5759:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading",staticStyle:{"position":"relative"}},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":"/user-order-stat/table"}},[_vm._v("条件搜索添加标签列表")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('template',{slot:"header"},[_vm._v(_vm._s(_vm.$route.meta.title))]),_vm._v(" "),_c('el-table',{staticClass:"margin b15",staticStyle:{"width":"100%"},attrs:{"data":_vm.table,"stripe":"","highlight-current-row":"","show-header":false}},[_c('el-table-column',{attrs:{"width":"180"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('b',[_vm._v(_vm._s(scope.row.label))])]}}])}),_vm._v(" "),_c('el-table-column',{scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"content-wrapper"},[_c('div',{class:scope.row.expanded ? 'content-full' : 'content-clamped'},[_vm._v("\n            "+_vm._s(scope.row.value)+"\n          ")]),_vm._v(" "),(!!scope.row.allowToggle)?_c('el-button',{staticClass:"toggle-btn",attrs:{"type":"text","size":"small"},on:{"click":function($event){return _vm.toggleContent(scope.$index)}}},[_vm._v("\n            "+_vm._s(scope.row.expanded ? '收起' : '展开')+"\n          ")]):_vm._e()],1)]}}])})],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/user_order_stat_detail.056baeae63677cdb5e58.js